import { DateFormat } from "../configurations/types/configuration.types";

export const formatDate = (date: Date | string, format: DateFormat = "DD/MM/YYYY"): string => {
  const d = typeof date === "string" ? new Date(date) : date;

  if (isNaN(d.getTime())) {
    return "Invalid Date";
  }

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = String(d.getFullYear());

  const separators: Record<DateFormat, string> = {
    "DD/MM/YYYY": "/",
    "MM/DD/YYYY": "/",
    "YYYY/MM/DD": "/",
    "DD-MM-YYYY": "-",
    "MM-DD-YYYY": "-",
    "YYYY-MM-DD": "-",
  };

  const separator = separators[format] || "/";

  switch (format) {
    case "DD/MM/YYYY":
      return `${day}${separator}${month}${separator}${year}`;
    case "MM/DD/YYYY":
      return `${month}${separator}${day}${separator}${year}`;
    case "YYYY/MM/DD":
      return `${year}${separator}${month}${separator}${day}`;
    case "DD-MM-YYYY":
      return `${day}${separator}${month}${separator}${year}`;
    case "MM-DD-YYYY":
      return `${month}${separator}${day}${separator}${year}`;
    case "YYYY-MM-DD":
      return `${year}${separator}${month}${separator}${day}`;
    default:
      return `${day}/${month}/${year}`;
  }
};

// For backwards compatibility
export const formatDateToDDMMYYYY = (date: Date | string): string => {
  return formatDate(date, "DD/MM/YYYY");
};